"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsControlsColorSpecificationShade_1 = __importDefault(require("./valueIsControlsColorSpecificationShade"));
const valueIsControlsColoSpecificationBase_1 = __importDefault(require("./valueIsControlsColoSpecificationBase"));
const valueIsNumber_1 = __importDefault(require("./valueIsNumber"));
const valueIsRecord_1 = __importDefault(require("./valueIsRecord"));
const valueIsUndefined_1 = __importDefault(require("./valueIsUndefined"));
const valueIsControlsColorDefinition = (value) => {
    if (!(0, valueIsRecord_1.default)(value)) {
        return false;
    }
    const { alpha, base, shade, } = value;
    if (!(0, valueIsUndefined_1.default)(alpha) && !(0, valueIsNumber_1.default)(alpha)) {
        return false;
    }
    if (!(0, valueIsControlsColoSpecificationBase_1.default)(base)) {
        return false;
    }
    if (!(0, valueIsControlsColorSpecificationShade_1.default)(shade)) {
        return false;
    }
    const test = {
        alpha: alpha || 0,
        base,
        shade,
    };
    return !!test;
};
exports.default = valueIsControlsColorDefinition;
